<template>

</template>

<script>
    import Cookies from 'js-cookie'
    export default {
        name: "login",
        data(){
            return {

            }
        },
        created() {
            //this.isLogin()
        },
        methods: {
            isLogin() {
                var _this = this,
                    access_token = '',
                    user_id = 0;
                access_token = this.$route.query.access_token;
                user_id = this.$route.query.user_id;
                //console.log(this.$route.query.access_token);return  false;
                //window.alert(access_token);

                //如果参数为空，跳转登录页面
                if (access_token == "" || access_token == 'null' || access_token == 'undefined') {
                    var screenWidth = window.screen.width;
                    //电脑端
                    if (screenWidth > 800) {
                        /*this.$http.get(this.pcDomainUrl+'/?app=member&act=isLogin&ajax=1').then((res) => {
                            if (res.data.errcode == 0){
                                _this.$store.commit('setUser',res.data.user);
                                _this.getStore(res.data.user.user_id);
                                _this.$router.push('/admin/home');
                            }else {
                                location.href = this.pcLoginUrl;
                            }
                        })*/
                        this.$router.push('/admin/login');
                    //手机端
                    } else {
                        location.href = this.loginDomain + '/jz/#/login?redirectUrl=' + encodeURIComponent(location.href)
                    }
                }else {
                    // 判断是否存在token，如果存在的话，则每个http header都加上token
                    Cookies.set('access_token', access_token);
                }
                return false;
                //window.alert(user_id);
                if (!user_id) {
                    var screenWidth = window.screen.width;
                        if (screenWidth > 800) {
                            location.href = this.pcLoginUrl;
                        } else {
                            location.href = this.loginDomain + '/jz/#/login?redirectUrl=' + encodeURIComponent(location.href)
                        }
                }else {
                    user_id = this.$route.query.user_id;
                    // 判断是否存在token，如果存在的话，则每个http header都加上token
                    Cookies.set('user_id', user_id)
                    this.mobileGetStore(user_id);
                    //console.log(this.$route.query.redirectUrl);
                    //console.log('aaa');
                    //console.log(this.$route.query.redirectUrl);
                    if (this.$route.query.redirectUrl){
                        //this.$router.push(this.$route.query.redirectUrl);
                    }else {
                        //this.$router.push('/');
                    }
                }
            },
            getStore(userId){
                var _this = this;
                this.$http.get('/v1/store/get-store',{params:{userId:userId}}).then((res) => {
                    //console.log(res.data)
                    if (res.data.errcode == 1) {
                        location.href = _this.pcDomainUrl+'/index.php?app=apply';
                    } else {
                        if (res.data.state == 0){
                            location.href = _this.pcDomainUrl+'/index.php?app=store&id='+res.data.id;
                        }else {
                            _this.$store.commit('setStore', res.data)
                            _this.$router.push('/admin/home')
                        }
                    }
                })
            },
            mobileGetStore(userId){
                var _this = this;
                this.$http.get('/v1/store/get-store',{params:{userId:userId}}).then((res) => {
                    //console.log(res.data)
                    if (res.data.errcode == 1) {
                        //console.log('aaaaa');
                        _this.$router.push('/mobile/store/edit')
                    } else {
                        if (res.data.state == 0){
                            //location.href = _this.pcDomainUrl+'/index.php?app=store&id='+res.data.id;
                            //_this.$router.push('/mobile/index')
                        }else {
                            _this.$store.commit('setStore', res.data)
                            //_this.$router.push('/mobile/index')
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
